import { resolveComponent as _resolveComponent, createVNode as _createVNode, vShow as _vShow, createElementVNode as _createElementVNode, withDirectives as _withDirectives, renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, withCtx as _withCtx, createSlots as _createSlots, createBlock as _createBlock, mergeProps as _mergeProps, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "q-pa-md",
  ref: "filters"
}
const _hoisted_2 = { class: "row q-col-gutter-sm" }
const _hoisted_3 = { class: "row full-width" }
const _hoisted_4 = { class: "row full-width" }
const _hoisted_5 = {
  key: 1,
  class: "card-view rounded-borders"
}
const _hoisted_6 = { key: 1 }
const _hoisted_7 = { key: 2 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_table_filters_menu = _resolveComponent("table-filters-menu")!
  const _component_filters_stackable = _resolveComponent("filters-stackable")!
  const _component_BaseTable = _resolveComponent("BaseTable")!
  const _component_data_card = _resolveComponent("data-card")!
  const _component_q_spinner = _resolveComponent("q-spinner")!
  const _component_q_inner_loading = _resolveComponent("q-inner-loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.enableFilters)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createVNode(_component_table_filters_menu, {
              options: _ctx.tableData.meta.columns,
              selections: _ctx.tableData.meta.defaults,
              "selected-sorted-value": _ctx.sorting,
              "ascending-value": _ctx.getAscendingValue,
              onToggleSort: _ctx.toggleAscending,
              onGroupingChange: _ctx.onGroupingChange,
              onSortingChange: _ctx.onSortingChange,
              onFilterChange: _ctx.onFilterChange,
              onToggleConditions: _ctx.onToggleConditions
            }, null, 8, ["options", "selections", "selected-sorted-value", "ascending-value", "onToggleSort", "onGroupingChange", "onSortingChange", "onFilterChange", "onToggleConditions"]),
            _withDirectives(_createElementVNode("div", _hoisted_3, [
              _createVNode(_component_filters_stackable, {
                ref: "filtersStackableRef",
                class: "full-width",
                fields: _ctx.tableData.meta.columns,
                "default-conditions": _ctx.tableData.meta.defaultConditions,
                onConditionStack: _ctx.setConditionStack,
                onCloseConditionStack: _ctx.onToggleConditions
              }, null, 8, ["fields", "default-conditions", "onConditionStack", "onCloseConditionStack"])
            ], 512), [
              [_vShow, _ctx.showConditions]
            ]),
            _createElementVNode("div", _hoisted_4, [
              _renderSlot(_ctx.$slots, "actions", { checkedData: _ctx.checkedData })
            ])
          ])
        ], 512))
      : _createCommentVNode("", true),
    (!_ctx.isLoading)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          (_ctx.filteredRows.length)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                (_ctx.displayType == 'table')
                  ? (_openBlock(), _createElementBlock("div", _mergeProps({ key: 0 }, _ctx.containerProps, {
                      class: "q-markup-table q-table__container q-table__card q-table--horizontal-separator q-table--dense q-table--flat q-table--bordered q-table--no-wrap my-sticky-header-table sticky-top",
                      style: {"max-height":"60vh"}
                    }), [
                      (_ctx.displayType === 'table')
                        ? (_openBlock(), _createElementBlock("table", _mergeProps({ key: 0 }, _ctx.wrapperProps, {
                            class: "my-sticky-header-table sticky-top q-table q-table--dense q-table--flat q-table--bordered q-table--no-wrap",
                            style: {"overflow-y":"auto","max-height":"60vh"},
                            onCheckedChange: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.onCheckedDataChange && _ctx.onCheckedDataChange(...args)))
                          }), [
                            (_ctx.groupedDataHeadings.length > 0)
                              ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.groupedDataHeadings, (group, index) => {
                                  return (_openBlock(), _createBlock(_component_BaseTable, {
                                    key: JSON.stringify(group),
                                    ref_for: true,
                                    ref: "baseTableRef",
                                    "check-header": "",
                                    columns: _ctx.tableData.meta.columns,
                                    "sorted-column": _ctx.sorting,
                                    "sorted-value": _ctx.getAscendingValue,
                                    onToggleSort: _ctx.toggleAscending,
                                    onSetSort: _ctx.onSortingChange,
                                    onCheckedChange: ($event: any) => (_ctx.onCheckedDataChangeGrouped($event, index)),
                                    onCollapsed: _cache[0] || (_cache[0] = ($event: any) => (_ctx.setCollapse($event))),
                                    filter: _ctx.filter,
                                    collapsed: _ctx.collapsedMap[group],
                                    "grouped-data-headings": _ctx.groupedDataHeadings,
                                    "group-heading": group ? group.toString() : undefined,
                                    rows: _ctx.listFilter(group),
                                    "all-rows": _ctx.groupedRows(group),
                                    "rows-length": _ctx.groupedRows(group).length,
                                    checkbox: _ctx.options?.checks,
                                    route: _ctx.options?.route,
                                    "cell-options": _ctx.options?.cellOptions,
                                    "table-ref": _ctx.tableRef
                                  }, _createSlots({ _: 2 }, [
                                    _renderList(Object.keys(_ctx.$slots), (slot, slotIndex) => {
                                      return {
                                        name: slot,
                                        fn: _withCtx((props) => [
                                          _renderSlot(_ctx.$slots, slot, _normalizeProps(_guardReactiveProps(props)))
                                        ])
                                      }
                                    })
                                  ]), 1032, ["columns", "sorted-column", "sorted-value", "onToggleSort", "onSetSort", "onCheckedChange", "filter", "collapsed", "grouped-data-headings", "group-heading", "rows", "all-rows", "rows-length", "checkbox", "route", "cell-options", "table-ref"]))
                                }), 128))
                              : (_openBlock(), _createBlock(_component_BaseTable, {
                                  key: 1,
                                  "use-list-index": "",
                                  ref: "baseTableRef",
                                  columns: _ctx.tableData.meta.columns,
                                  "sorted-column": _ctx.sorting,
                                  "sorted-value": _ctx.getAscendingValue,
                                  onToggleSort: _ctx.toggleAscending,
                                  onSetSort: _ctx.onSortingChange,
                                  onCheckedChange: _ctx.onCheckedDataChange,
                                  onCollapsed: _cache[1] || (_cache[1] = ($event: any) => (_ctx.setCollapse($event))),
                                  filter: _ctx.filter,
                                  collapsed: _ctx.collapse,
                                  "group-heading": _ctx.t('data.allData'),
                                  rows: _ctx.list,
                                  "all-rows": _ctx.filteredRows,
                                  "rows-length": _ctx.filteredRows.length,
                                  checkbox: _ctx.options?.checks,
                                  route: _ctx.options?.route,
                                  "cell-options": _ctx.options?.cellOptions,
                                  "table-ref": _ctx.tableRef
                                }, _createSlots({ _: 2 }, [
                                  _renderList(Object.keys(_ctx.$slots), (slot, slotIndex) => {
                                    return {
                                      name: slot,
                                      fn: _withCtx((props) => [
                                        _renderSlot(_ctx.$slots, slot, _normalizeProps(_guardReactiveProps(props)))
                                      ])
                                    }
                                  })
                                ]), 1032, ["columns", "sorted-column", "sorted-value", "onToggleSort", "onSetSort", "onCheckedChange", "filter", "collapsed", "group-heading", "rows", "all-rows", "rows-length", "checkbox", "route", "cell-options", "table-ref"]))
                          ], 16))
                        : _createCommentVNode("", true)
                    ], 16))
                  : (_openBlock(), _createElementBlock("div", _hoisted_5, [
                      (_ctx.groupedDataHeadings.length > 0)
                        ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.groupedDataHeadings, (group) => {
                            return (_openBlock(), _createBlock(_component_data_card, {
                              key: group,
                              columns: _ctx.tableData.meta.columns,
                              rows: _ctx.groupedRows(group),
                              "group-heading": group.toString(),
                              collapsed: _ctx.collapse,
                              filter: _ctx.filter
                            }, null, 8, ["columns", "rows", "group-heading", "collapsed", "filter"]))
                          }), 128))
                        : (_openBlock(), _createBlock(_component_data_card, {
                            key: 1,
                            columns: _ctx.tableData.meta.columns,
                            rows: _ctx.filteredRows,
                            collapsed: _ctx.collapsed,
                            filter: _ctx.filter
                          }, null, 8, ["columns", "rows", "collapsed", "filter"]))
                    ]))
              ], 64))
            : (_openBlock(), _createElementBlock("div", _hoisted_6, _toDisplayString(_ctx.t('data.noData')), 1))
        ], 64))
      : _createCommentVNode("", true),
    (_ctx.isLoading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
          _createVNode(_component_q_inner_loading, { showing: _ctx.isLoading }, {
            default: _withCtx(() => [
              _createVNode(_component_q_spinner, {
                label: "Please wait...",
                size: "50px",
                color: "primary"
              })
            ]),
            _: 1
          }, 8, ["showing"])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}